import { useId } from "react";

type GradientBorder = {
  className?: string;
  radius?: string;
};

export default function GradientBorder({ className, radius = "31.5" }: GradientBorder) {
  const buttonGradientId = useId();
  return (
    <svg
      className={`pointer-events-none absolute inset-0 z-0 h-full w-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <defs>
        <linearGradient
          id={buttonGradientId}
          x1="126"
          y1="0"
          x2="126"
          y2="64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0DFC1" />
          <stop offset="0.791452" stopColor="#C89452" />
          <stop offset="1" stopColor="#B07F44" />
        </linearGradient>
      </defs>

      <rect
        x="0.5"
        y="0.5"
        width="calc(100% - 1px)"
        height="calc(100% - 1px)"
        rx={radius}
        ry={radius}
        stroke={`url(#${buttonGradientId})`}
        strokeWidth="1"
      />
    </svg>
  );
}
